import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React from "react";
import MuiIcon from "../../../../../shared/styles/mui/helpers/mui-icon.helper";

interface IProps {
  onReload: () => void;
  handleCreateReportSubscriptionClick: () => void;
}

function QueuedReportsToolbarComponent({
  onReload,
  handleCreateReportSubscriptionClick,
}: IProps) {
  return (
    <Grid
      paddingX={2}
      container
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
    >
      {/* Reload */}
      <Tooltip title="Reload">
        <IconButton color="secondary" onClick={onReload}>
          {MuiIcon.RELOAD()}
        </IconButton>
      </Tooltip>

      {/* Title */}
      <Typography sx={{ flexGrow: 1 }} variant="subtitle2">
        Queued Reports List
      </Typography>
    </Grid>
  );
}
export default QueuedReportsToolbarComponent;
